// extracted by mini-css-extract-plugin
module.exports = {"carCareNavCard":"car-care-menu_carCareNavCard__9YgOU","list":"car-care-menu_list__sYuqw"};